// El backend manda la carga del pedido en un solo string con los items
// separados por " -- ". Se parsea igual en la tarjeta (carga destacada) y en
// el detalle expandible, así que vive acá para no duplicar la lógica.
export const parseProductosPedido = (pedido) =>
  pedido && pedido.producto
    ? pedido.producto
        .split(" -- ")
        .map((item) => item.trim())
        .filter(Boolean)
    : [];
